import styled from 'styled-components';

const Panel = styled.div`
  display: flex;
  margin: auto;
  padding: 16px;
`;

const IconSpacer = styled.div({
  display: 'flex',
  justifyContent: 'center',
  paddingBottom: 16, // 24 - 4 - 4 (for spacer)
  color: '#FFCA61',
});

const ButtonSpacer = styled.div({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  paddingTop: 32, // 40 - 4 - 4 (for spacer)
});

const Text = styled.div`
  text-align: center;
  color: ${({ theme }: any) => theme.color.gray8};
  font-size: ${({ theme }: any) => theme.fontSize.lg}px;
  font-weight: ${({ theme }: any) => theme.fontWeight.normal};
  line-height: ${({ theme }: any) => theme.lineHeight.lg};
  max-width: 396px;
`;

const Heading = styled.div`
  text-align: center;
  color: ${({ theme }: any) => theme.color.gray9};
  font-size: ${({ theme }: any) => theme.fontSize.xl}px;
  font-weight: ${({ theme }: any) => theme.fontWeight.semiBold};
  line-height: ${({ theme }: any) => theme.lineHeight.xl};
`;

const Shared = styled.div({
  display: 'flex',
  flexDirection: 'column',
  paddingTop: 24,
  maxWidth: 396,
  width: '100%',
});

const SharedItem = styled.a`
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 12px 16px;
  border: 1px solid ${({ theme }: any) => theme.color.gray4};
  border-radius: 4px;
  color: ${({ theme }: any) => theme.color.gray9};
  text-decoration: none;

  & + & {
    margin-top: 8px;
  }

  &:hover {
    border-color: ${({ theme }: any) => theme.color.blue5};
  }
`;

const SharedItemName = styled.div`
  font-size: ${({ theme }: any) => theme.fontSize.md}px;
  font-weight: ${({ theme }: any) => theme.fontWeight.semiBold};
  line-height: ${({ theme }: any) => theme.lineHeight.md};
`;

const SharedItemDetail = styled.div`
  color: ${({ theme }: any) => theme.color.gray7};
  font-size: ${({ theme }: any) => theme.fontSize.sm}px;
  line-height: ${({ theme }: any) => theme.lineHeight.sm};
`;

const Actions = styled.div({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  gap: 8,
  paddingTop: 32, // 40 - 4 - 4 (for spacer)
});

export {
  Actions,
  ButtonSpacer,
  Heading,
  IconSpacer,
  Panel,
  Shared,
  SharedItem,
  SharedItemDetail,
  SharedItemName,
  Text,
};
